import { Injectable } from '@angular/core';
import { SurveyUserTypes } from '../constants-types/Enums';
import { OiLink, Oi1Link } from '../core-data-model/OiLink.model';
import {
    ShortenedUrlInfoServer,
    ShortenedOi1UrlServer
} from '../core-data-model/UrlShortenerApi.serverinterface';
import { Util } from '../core-utilities/Util';

@Injectable({
    providedIn: 'root'
})
export class UrlShortenerTransformers {
    constructor(private util: Util) {}
    serverToClient(shortenedUrlServerList: ShortenedUrlInfoServer): OiLink {
        return {
            linkName: shortenedUrlServerList.linkName,
            longUrl: shortenedUrlServerList.longUrl,
            shortenedUrl: shortenedUrlServerList.shortenedUrl,
            kioskMode: shortenedUrlServerList.kioskMode === 'True', // this feels gross, and it is. Can't get server response to gel
            sendAnalystCompletionEmail:
                shortenedUrlServerList.sendAnalystCompletionEmail === 'True',
            jobId: shortenedUrlServerList.jobId,
            folderId: shortenedUrlServerList.folderId,
            personType: SurveyUserTypes[
                shortenedUrlServerList.personType as any
            ] as any,
            sendCogAfterBA: shortenedUrlServerList.sendCAOnBA === 'True',
            autoSendReport: shortenedUrlServerList.autoSend === 'True',
            createdDateTime: this.util.newDate(
                shortenedUrlServerList.createdTime
            ),
            stakeHoldersEmailList: shortenedUrlServerList.stakeHoldersEmailList
        };
    }

    serverListToClientList(
        shortenedUrlServerList: ShortenedUrlInfoServer[]
    ): OiLink[] {
        return shortenedUrlServerList.map((info) => this.serverToClient(info));
    }

    serverOi1ListToClientOi1List(
        shortenedOi1UrlServerList: ShortenedOi1UrlServer[]
    ): Oi1Link[] {
        return shortenedOi1UrlServerList.map(
            (info) => new Oi1Link(this.serverToClient(info))
        );
    }
}
